module.exports = __webpack_public_path__ + "img/1.81663a85.png";